import { GeneratedReportAsset } from '@/shared/api/protocol-ts/model/dto_asset_pb';

export const getGeneratedReportOrder = (
  generatedReportAsset: GeneratedReportAsset | undefined,
) => {
  if (
    generatedReportAsset?.Content.case === 'CBCTGPToothSlice' &&
    generatedReportAsset.Content.value.Metadata.case === 'Regular' &&
    typeof generatedReportAsset.Content.value.Metadata.value.Order === 'number'
  ) {
    return generatedReportAsset.Content.value.Metadata.value.Order;
  }
};
